/*
 * @Description: 自定义加密规则
 */
import CryptoJS from 'crypto-js'
export function encrypt (word, key) {
  var _key = CryptoJS.enc.Utf8.parse(key)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, _key, { iv: _key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
export function decrypt (text, key) {
  if (!text) {
    return text
  }
  var _key = CryptoJS.enc.Utf8.parse(key)
  var result = CryptoJS.AES.decrypt(text, _key, {
    iv: _key,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  return result.toString(CryptoJS.enc.Utf8)
}
